export default __webpack_public_path__ + "static/media/copyshop.2b45aae5.jpeg";